import React, {useEffect, useRef} from "react"
import {tryToLoad} from "../helpers"


const navOptions = {
  'draggable' : false 
};

const SideNav = (props, ref) => {

  const sideNavRef = useRef(null);

  useEffect(() => { 
    tryToLoad( () => window.M.Sidenav.init(sideNavRef.current , navOptions));    
  },[]);

  return(
     <div ref = {sideNavRef} {...props}>
      <a className="sidenav-close"></a>
     <ul>
      <li><a target="_blank" href="https://www.eliamykonos.gr/accommodation/">Rooms & Suites</a></li>
      <li><a target="_blank" href="https://www.eliamykonos.gr/beach-restaurant/">Restaurant</a></li>
      <li><a target="_blank" href="https://www.eliamykonos.gr/the-beach/">Beach</a></li>
      <li><a target="_blank" href="https://www.eliamykonos.gr/events/">Events</a></li>
      <li><a target="_blank" href="https://www.eliamykonos.gr/boutique/">Boutique</a></li>
      <li><a target="_blank" href="https://www.eliamykonos.gr/contact/">Contact</a></li>
    </ul>
    <ul>
      <li>Elia Mykonos Resort</li>
      <li><a href="tel:+302289071204">T. +30 22890 71204</a></li>
      <li><a href="mailto:info@eliamykonos.gr">E. info@eliamykonos.gr</a></li>
    </ul>
    <ul>
      <li><strong>Address</strong></li>
      <li>84600 Elia Beach, Mykonos Greece</li>
    </ul>
    </div>
  );
};


export default SideNav;